define(["marionette", "jquery", "underscore", "./template/roleMapTemplate.html"], function (
  Marionette,
  $,
  _,
  TouchpointMapTemplate,
) {
  "use strict";

  const RoleMapView = {};

  RoleMapView.roleMapView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: TouchpointMapTemplate,
    events: {
      "change #authoringRoles": function (e) {
        const kbRoleIds = [];
        $(e.target)
          .children("option:selected")
          .each(function () {
            // jQuery calls this with the selected option as "this"
            const selectedOption = this;
            if (selectedOption.value) {
              kbRoleIds.push(+selectedOption.value);
            }
          });
        this.trigger("change:authoringRoles", kbRoleIds);
      },
    },
    triggers: {
      "click #chkAuthoring": "toggle:authoring",
      "click #chkReporting": "toggle:reporting",
      "click #chkAdHocReporting": "toggle:adHocReporting",
      "click #chkAdHocReportingAdmin": "toggle:adHocReportingAdmin",
      "click #chkReviewer": "toggle:reviewer",
      "click #chkReviewerWithAttributes": "toggle:reviewerWithAttributes",
      "click #chkTopicImportAPI": "toggle:topicImportAPI",
    },
  });

  return RoleMapView;
});
